import { ITypedReduxAction } from '../../types/redux/actionType';
import { IFavoriteEntity } from '../../types/results';

export enum EChatActionTypes {
  Open = 'chat/open',
  Close = 'chat/close',
}

export interface IOpenChatPayload {
  offer: IFavoriteEntity | null;
  position: number;
  defaultMessage?: string;
}

export type TChatOpen = ITypedReduxAction<EChatActionTypes.Open, IOpenChatPayload>;
export type TChatClose = ITypedReduxAction<EChatActionTypes.Close>;

export type TChatActions = TChatOpen | TChatClose;
